const nullUserInfo = {
  id: null, userType: '', username: '', givenName: '', familyName: '', email: '', isActive: false,
  onSuccessCallback: null
};
export default nullUserInfo;
